module.exports = __webpack_public_path__ + "img/1728349090565-Screenshot_8-10-2024_85753_www.instagram.com.jpeg.726ada30.webp";